

export default class GoogleApi {


    static searchPlaces = (value: string)=> {

        const url = "https://places.googleapis.com/v1/places:autocomplete"

        return fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Goog-Api-Key": gdConfig.googleApiKey
            },
            body: JSON.stringify({input: value})
        })
            .then((response: Response) => response.json())
            .catch((e: Error) => e);
    }

    static getPlaceLocation = (placeId: ID) => {

        const url = `https://places.googleapis.com/v1/places/${placeId}`

        return fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-Goog-Api-Key": gdConfig.googleApiKey,
                'X-Goog-FieldMask': 'location,displayName'
            },
        })
            .then((response: Response) => response.json())
            .catch((e: Error) => e);
    }

}
